<template>
  <SfDropdown
    dropdown-id="checkTypesDropdownFilter"
    :is-full-width="true"
    :is-open="isOpen"
    variant="seamless"
    unstyled-trigger
    @dropdown-clicked="toggleDropdown"
    @dropdown-closed="closeDropdown"
  >
    <template #trigger>
      <SfButtonDs
        icon-after="caret-down"
        class="tw-w-full sf-button--full-width-label"
      >
        <span class="tw-truncate">{{ triggerLabel }}</span>
      </SfButtonDs>
    </template>

    <template #menu>
      <div class="tw-p-2 tw-overflow-hidden">
        <SfDropdownItemGroup :with-separator="false">
          <SfDropdownItem
            v-for="type in options"
            :key="type.value"
            :has-checkmark="pageStore.checkTypeFilter === type.value"
            :has-border="false"
            :is-rounded="true"
            :class="{
              'tw-font-medium': pageStore.checkTypeFilter === type.value,
            }"
            @click="selectValue(type.value)"
          >
            {{ type.label }}
          </SfDropdownItem>
        </SfDropdownItemGroup>
      </div>
    </template>
  </SfDropdown>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import SfButtonDs from '@app/shared/vue/components/sf-button/sf-button-ds.vue'
import SfDropdown from '@app/shared/vue/components/sf-dropdown/sf-dropdown.vue'
import SfDropdownItemGroup from '@app/shared/vue/components/sf-dropdown/sf-dropdown-item-group.vue'
import SfDropdownItem from '@app/shared/vue/components/sf-dropdown/sf-dropdown-item.vue'
import { useDropdown } from '@app/shared/pinia/dropdown'
import useI18n from '@app/shared/vue/composables/use-I18n'
import { useSfAssistantChecksPage } from '../stores/page'

const I18n = useI18n()
const dropdownStore = useDropdown()
const pageStore = useSfAssistantChecksPage()

const options = [
  {
    label: I18n.t('assistant_check.filters.labels.any'),
    value: 'any',
  },
  {
    label: I18n.t('assistant_check.filters.labels.mentions'),
    value: 'mentions',
  },
]

const isOpen = computed(
  () => dropdownStore.currentDropdownId === 'checkTypesDropdownFilter'
)

function toggleDropdown(): void {
  dropdownStore.toggleDropdown('checkTypesDropdownFilter')
}

function closeDropdown(): void {
  dropdownStore.closeDropdown()
}

function selectValue(value: string): void {
  pageStore.checkTypeFilter = value
  closeDropdown()
}

const anyLabel = I18n.t('assistant_check.filters.labels.any')
const checksLabel = I18n.t(
  'assistant_check.filters.check_types.trigger_labels.checks'
)
const defaultLabel = `${checksLabel} ${anyLabel}`

const triggerLabel = computed(() => {
  if (!pageStore.checkTypeFilter || pageStore.checkTypeFilter === 'any') {
    return defaultLabel
  }

  const found = options.find((o) => o.value === pageStore.checkTypeFilter)

  return found ? `${checksLabel} ${found.label}` : defaultLabel
})
</script>
